export type StabilizePickedFilesOptions = {
  /** Used when the native picker omits MIME (common on Android). */
  defaultMimeType?: string;
};

/**
 * Clone picked files into memory before the picker `<input>` is cleared/removed.
 * Avoids Android WebView losing blob reads after `input.value = ""` / `input.remove()`.
 */
export async function stabilizePickedFiles(
  files: File[],
  options?: StabilizePickedFilesOptions,
): Promise<File[]> {
  const stable: File[] = [];
  const fallbackType = options?.defaultMimeType || "application/octet-stream";

  for (const file of files) {
    try {
      const buffer = await file.arrayBuffer();
      if (buffer.byteLength > 0) {
        stable.push(
          new File([buffer], file.name || "upload", {
            type: file.type || fallbackType,
            lastModified: file.lastModified,
          }),
        );
        continue;
      }
    } catch {
      // Fall through to keep the original reference when clone fails.
    }

    if (file.size > 0) {
      stable.push(file);
    }
  }

  return stable;
}
